import type { BaremetalServer } from '@/entities/baremetal';
import type { ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getServers = (): Promise<{ baremetals: BaremetalServer[]; meta: ResponseMeta }> =>
  request({
    url: '/baremetals/',
  });
